import {
	Pipe,
	PipeTransform
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StringUtils } from '@utils/helpers';

/**
 * Pipe for sanitizing html string. If string is empty return -
 * @param value Insert html string to sanitize
 * @return string or if its empty return '-'
 * */
@Pipe( {
	name: 'bypassSecurityTrustHtmlPipe',
	standalone: true
} )
export class BypassSecurityTrustHtmlPipe implements PipeTransform {
	constructor( private sanitizer: DomSanitizer ) {
	}

	transform( value: string, ...args: unknown[] ): unknown {
		return this.sanitizer.bypassSecurityTrustHtml( StringUtils.replaceEmptyValue( value, '-' ) );
	}

}
